import React, { memo } from "react";
import useCreateMerchantForm from "./index.hooks";
import { DialogActions, TextField } from "@material-ui/core";
import { AppButton } from "components/index";

type CreateMerchantFormProps = {};

const CreateMerchantForm = ({}: CreateMerchantFormProps) => {
  const {
    classes,
    register,
    onSubmit,
    handleSubmit,
    errors,
    onClose,
    isCreatingMerchant,
    t,
  } = useCreateMerchantForm();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextField
        variant="outlined"
        label={t("Nome")}
        name="name"
        inputRef={register}
        error={!!errors.name}
        helperText={errors.name?.message}
        fullWidth
        disabled={isCreatingMerchant}
      />
      <DialogActions classes={classes.actions}>
        <AppButton color="secondary" onClick={onClose}>
          {t("Annulla")}
        </AppButton>
        <AppButton disabled={isCreatingMerchant} color="primary" type="submit">
          {t("Aggiungi")}
        </AppButton>
      </DialogActions>
    </form>
  );
};

export default memo(CreateMerchantForm);
